import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'; // ES6
import { Icon, Button, Spin } from 'antd';

import { convertirTextAMomentLocal } from '../../commons/gestioDates';
import { obtenirComentaris, eliminarComentari } from '../../actions/avis';
import { RETARD_MILISEGONS_APARICIO_SPINNER } from '../../constants';

import seguretatWrapper from '../seguretat/seguretatWrapper';
import { esPotEliminarComentari } from '../../commons/callbacksSeguretat';

const INTERVAL_PETICIO_COMENTARIS_EN_MINUTS = 3;
const INTERVAL_PETICIO_COMENTARIS_EN_MS = INTERVAL_PETICIO_COMENTARIS_EN_MINUTS * 1000 * 60;

class AvisInformacioAddicionalComentarisLlista extends Component {

    constructor(props) {
        super(props);
        this.actualitzarComentaris = this.actualitzarComentaris.bind(this);
        this.eliminarComentari = this.eliminarComentari.bind(this);
    }

    componentDidMount() {
        this.props.obtenirComentaris();
        this.objecteIntervalPeticioPeriodicaAlServidor = setInterval(() => this.actualitzarComentaris(), INTERVAL_PETICIO_COMENTARIS_EN_MS);
    }

    actualitzarComentaris() {
        if (!this.props.estaPeticioObtenirComentarisEnCurs && this.props.idComentariEnProcesEliminar === null) {
            this.props.obtenirComentaris();
        }
    }

    eliminarComentari(idComentari) {
        if (this.props.idComentariEnProcesEliminar === null) {
            this.props.eliminarComentari(idComentari);
        }
    }

    componentWillUnmount() {
        clearInterval(this.objecteIntervalPeticioPeriodicaAlServidor);
    }

    obtenirIconaEliminarComentari(idComentari, idUsuariComentari, idComentariEnProcesEliminar) {
        let icona;

        const IconAmbSeguretat = seguretatWrapper(Icon, esPotEliminarComentari(idUsuariComentari));

        if (idComentari === idComentariEnProcesEliminar) {
            icona = <IconAmbSeguretat
                type="loading"
                className='avis-informacio-addicional-comentaris-llista-comentari-icona-eliminar'
            />;
        } else {
            icona = <IconAmbSeguretat
                className='icona-eliminar'
                type="delete"
                onClick={() => this.eliminarComentari(idComentari)}
            />;
        }

        return icona;
    }

    render() {
        const estaPeticioObtenirComentarisEnCurs = this.props.estaPeticioObtenirComentarisEnCurs;

        return (
            <div>
                <Button
                    className='avis-informacio-addicional-comentaris-llista-boto-actualitzar'
                    loading={estaPeticioObtenirComentarisEnCurs}
                    icon="sync"
                    size="small"
                    shape="circle"
                    onClick={this.actualitzarComentaris}
                />
                <Spin
                    wrapperClassName='avis-informacio-addicional-comentaris-llista-contingut-spinner'
                    spinning={estaPeticioObtenirComentarisEnCurs}
                    delay={RETARD_MILISEGONS_APARICIO_SPINNER}
                >
                    <div className='avis-informacio-addicional-comentaris-llista'>
                        {this.props.comentaris.map((comentari) => {
                            const dataComentari = convertirTextAMomentLocal(comentari.data);
                            const dataComentariText = dataComentari.format('YYYY-MM-DD HH:mm');

                            return (
                                <div key={comentari.id} className='avis-informacio-addicional-comentaris-llista-comentari'>
                                    <div className='avis-informacio-addicional-comentaris-llista-comentari-data-i-codi-usuari'>
                                        <b>{dataComentariText}</b> <i>[{comentari.codiUsuari}]</i>
                                        {this.obtenirIconaEliminarComentari(comentari.id, comentari.idUsuari, this.props.idComentariEnProcesEliminar)}
                                    </div>
                                    <div className='avis-informacio-addicional-comentaris-llista-comentari-text salt-de-linia'>
                                        {comentari.text}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </Spin>
            </div>
        );
    }
}

AvisInformacioAddicionalComentarisLlista.propTypes = {
    comentaris: PropTypes.array,
    estaPeticioObtenirComentarisEnCurs: PropTypes.bool,
    idComentariEnProcesEliminar: PropTypes.number,
    obtenirComentaris: PropTypes.func,
    eliminarComentari: PropTypes.func
};

const mapStateToProps = (state) => ({
    comentaris: state.avis.visualitzacio.comentaris.tots,
    estaPeticioObtenirComentarisEnCurs: state.avis.visualitzacio.comentaris.peticioObtenirEnCurs,
    idComentariEnProcesEliminar: state.avis.visualitzacio.comentaris.idComentariEnProcesEliminar
});

export default connect(mapStateToProps, { obtenirComentaris, eliminarComentari })(AvisInformacioAddicionalComentarisLlista);



// WEBPACK FOOTER //
// ./src/components/avis/avisInformacioAddicionalComentarisLlista.js